import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";
import logger from "@src/helpers/logger";

const OPTIMIZELY_ADD_TO_BAG_KEY = "Add To Bag";
const BAG_SDK_ADD_TO_BAG_EVENT_KEY = "addToBag:started";

const getVariantIds = variantIdsOrItems =>
  variantIdsOrItems.map(variantIdOrItem =>
    typeof variantIdOrItem === "object" && variantIdOrItem !== null
      ? variantIdOrItem.variantId
      : variantIdOrItem
  );

const handleAddToBag = bagSdk => async (_event, ...variantIdsOrItems) => {
  const variantIds = getVariantIds(variantIdsOrItems);

  let bagID;

  try {
    ({
      bag: { id: bagID }
    } = await bagSdk.getOrCreateBag());
  } catch (_) {
    logger.warn(
      "Attempted to track MVT Add To Bag event without bag ID -- discarding"
    );

    return;
  }

  const featuresSdk = await sdkInstanceProvider("features");

  variantIds.forEach(variantID => {
    featuresSdk.track(OPTIMIZELY_ADD_TO_BAG_KEY, null, null, {
      bagID,
      variantID
    });
  });
};

const trackAddToBag = async () => {
  const bagSdk = await sdkInstanceProvider("bag");

  $(bagSdk).on(BAG_SDK_ADD_TO_BAG_EVENT_KEY, handleAddToBag(bagSdk));
};

export default trackAddToBag;
